<template>
	<div>
		<Overview168 v-if="isOverview168" :moduleData="props.moduleData" />
		<Overview v-else :moduleData="props.moduleData" />
		<slot name="footer"></slot>
	</div>
</template>




<script setup>
import { computed } from 'vue';
import { isBuild } from '@/utils/const';
import Overview168 from './overview_168.vue';
import Overview from '@rebuild/materials/shared/custom/Overview.vue';
import { useCustomCore } from '@rebuild/materials/shared/custom/context';

const props = defineProps({
	moduleData: {
		type: Object,
		default: () => ({})
	}
});

const { getRealModuleId } = useCustomCore();

// 父级通过 getModuleProps(item) 传入 moduleData，需用 props.moduleData.moduleId；无参时 context 只从 route 取，列表页 URL 通常没有 moduleId
const getModuleId = computed(() => {
	return getRealModuleId(props.moduleData?.moduleId);
});

//168为康耐特已经订阅的财务报告自定义模块id, 347为测试环境随便新建的一个自定义模块id
const isOverview168 = computed(() => {
	return isBuild ? getModuleId.value == 168 : getModuleId.value == 347;
});
</script>